import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { ThemeContext } from 'styled-components';
var Loading = function () {
    var theme = useContext(ThemeContext);
    console.log(theme);
    return (React.createElement("div", { style: {
            display: 'flex',
            justifyContent: 'center',
            width: "".concat(100, "%"),
        } },
        React.createElement(FontAwesomeIcon, { color: theme.brand_primary_color, icon: faSpinner, spin: true, size: "3x" })));
};
export default Loading;
